/**
 * APIL Url: ADAC.Internet.Types.SimulationType
 * 
 */
export enum SimulationTypeApi {
	None = 0,  // None
	OnlyValidate = 1  // OnlyValidate
};